import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'patientName',
  standalone: false
})
export class PatientNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value
    }

    let name = value.trim()

    if (name.startsWith(',')) {
      name = name.slice(1)
    }

    if (name.endsWith(',')) {
      name = name.slice(0, name.length - 2)
    }

    return name
  }
}
